import { LocalizationMap } from '@Primitive/Localization/Localization';
// ------------------------------------------------------------------------------------------------ 
export const VideoPlayerLocalizationTextMapKey: string = "Primitive_VideoPlayer";
// ------------------------------------------------------------------------------------------------ 
export function GetVideoPlayerLocalizationDictionary(): LocalizationMap {
    return {
        'Audio Player': 'Audio Player',
        'Video Player': 'Video Player',
        'Pause': 'Pause',
        'Play': 'Play',
        'Play Video': 'Play Video',
        'Mute': 'Mute',
        'Unmute': 'Unmute',
        'Close': 'Close',
        'Replay': 'Replay',
        'Time': 'Time',
        'Current Time': 'Current Time',
        'Non-Fullscreen': 'Non-Fullscreen',
        'Fullscreen': 'Fullscreen',
        'Duration': 'Duration',
        'Remaining Time': 'Remaining Time',
        'Chapters': 'Chapters',
        'Descriptions': 'Descriptions',
        'Subtitles': 'Subtitles',
        'Captions': 'Captions',
        'Audio Track': 'Audio Track',
        'Playback Rate': 'Playback Rate',
    };
}
// ------------------------------------------------------------------------------------------------